// extracted by mini-css-extract-plugin
export default {"container":"TypingMessage_container__B20kF","slideIn":"TypingMessage_slideIn__l1dZV","name":"TypingMessage_name__0boWK"};